/* What a link into «Играть вместе» asked the widget to do on arrival
 * (ARCHITECTURE §13).
 *
 * The catalog's band under the hero has two buttons into the section —
 * «Выбрать лобби» and «Автоподбор» — and both are plain links to `/play`, which
 * is all they are without JavaScript and in a new tab. With it, a plain click
 * also leaves the widget a note: `list` (open on the list of lobbies, even for
 * a reader whose page would open on a lobby of their own) or `auto` (start
 * auto-search, exactly as the widget's own button does). The second one is the
 * reason this module exists: it makes the search one click from the catalog
 * instead of two.
 *
 * The note travels through sessionStorage and NOT through the URL, on purpose.
 * A URL that starts a search is a URL anybody can link to, and a search can
 * seat the reader inside the very request (§15) — in a pack they would pay a
 * penalty to walk out of (§16). A note in this tab's storage can only have been
 * written by a click on this origin. It also survives the one detour a guest
 * takes on the way: signing in is a trip to Steam and back to `/play` in the
 * same tab, and the search starts on the return.
 *
 * Read once — the widget takes the note as it boots (resources/js/play/store.js)
 * — and only while it is fresh: a reader who clicked, went to Steam and never
 * came back must not find a search starting on some later visit.
 *
 * On the catalog this module only listens for the click; on `/play` it only
 * hands the note over. One file for both, so the key and its lifetime have one
 * home.
 */

(function (window, document) {
  'use strict';

  var RHF = window.RHF || (window.RHF = {});

  var KEY = 'rhf.play.intent.v1';

  /* Long enough for a Steam sign-in with a Steam Guard code typed in, short
     enough that a note left behind is gone by the next time anybody looks. */
  var TTL_MS = 10 * 60 * 1000;

  var KINDS = { list: true, auto: true };

  /* Reading the property itself can throw where storage is blocked. */
  function storage() {
    try {
      return window.sessionStorage || null;
    } catch (err) {
      return null;
    }
  }

  function leave(kind) {
    var store = storage();

    if (!store || !Object.prototype.hasOwnProperty.call(KINDS, kind)) {
      return;
    }

    try {
      store.setItem(KEY, JSON.stringify({ kind: kind, at: Date.now() }));
    } catch (err) {
      /* No storage, no note: the link still opens the section. */
    }
  }

  /**
   * The note's kind while it is fresh, or null. A fresh note stays where it is
   * — the caller decides whether it is spent — and a stale or unreadable one
   * is thrown away here, since nobody will ever act on it.
   */
  function peek() {
    var store = storage();
    var kind = null;
    var raw = null;

    if (!store) {
      return null;
    }

    try {
      raw = store.getItem(KEY);

      var note = raw === null ? null : JSON.parse(raw);
      var age = note ? Date.now() - Number(note.at) : NaN;

      if (note && Object.prototype.hasOwnProperty.call(KINDS, note.kind) && age >= 0 && age < TTL_MS) {
        kind = note.kind;
      }
    } catch (err) {
      /* A note that does not parse is no note. */
    }

    if (kind === null && raw !== null) {
      clear();
    }

    return kind;
  }

  function clear() {
    var store = storage();

    if (!store) {
      return;
    }

    try {
      store.removeItem(KEY);
    } catch (err) {
      /* Nothing to clear with. */
    }
  }

  /* A plain primary click only. A modified one opens another tab or window,
     whose storage is its own (or a copy of this one — browsers disagree), and
     the link then does exactly what its href says, which is the promise the
     markup makes without this module. Delegated, so the band needs no id and
     a second such link anywhere on the page would work the same way. */
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0
      || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    var target = event.target;
    var link = target && typeof target.closest === 'function' ? target.closest('a[data-play-intent]') : null;

    if (link) {
      leave(link.getAttribute('data-play-intent'));
    }
  });

  RHF.playIntent = {
    peek: peek,
    clear: clear
  };
})(window, document);
